<template>
  <div>
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-between items-center p-3">
        <div class="flex gap-3">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            @click="changeTab(tab)"
            :class="{
              ' text-white bg-primary': selectedTab == tab,
            }"
            class="text-sm text-center hover:bg-primary bg-gray-200 hover:text-white cursor-pointer p-3"
          >
            {{ tab }}
          </div>
        </div>
        <div class="flex gap-4">
          <input
            v-if="selectedTab == 'Goals'"
            type="text"
            placeholder="Search Goal"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
          <input
            v-if="selectedTab == 'Compentencies'"
            type="text"
            placeholder="Search Competency"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
          <input
            type="text"
            onfocus="(this.type='date')"
            onbur="(this.type='text')"
            placeholder="Due Date"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
          <input
            type="text"
            placeholder="Filter By"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
        </div>
      </div>
      <Goals :key="gKey" v-if="selectedTab == 'Goals'"></Goals>
      <Compentencies
        :key="cKey"
        v-if="selectedTab == 'Compentencies'"
      ></Compentencies>
    </div>
  </div>
</template>

<script>
import Goals from "./goals.vue";
import Compentencies from "./compentencies.vue";
export default {
  name: "ManagerReviewsHome",
  components: { Goals, Compentencies },
  data() {
    return {
      selectedTab: "Goals",
      gKey: 0,
      cKey: 1,
      tabs: ["Goals", "Compentencies"],
    };
  },
  methods: {
    changeTab(tab) {
      this.selectedTab = tab;
      switch (this.selectedTab) {
        case "Goals":
          this.gKey++;
          break;
        case "Compentencies":
          this.cKey++;
          break;
      }
    },
  },
};
</script>
